import {
    GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_USERS_FAILURE, SET_FILTER,
} from '../constants/users.constants';

export const users_actions = {
    getUsersRequest: (filters, init) => ({ type: GET_USERS_REQUEST, filters, init }),
    getUsersRequestSuccess: payload => ({ type: GET_USERS_SUCCESS, payload }),
    setFilter: (path, value) => ({ type: SET_FILTER, path, value }),
    getUsersRequestFailure: error => ({ type: GET_USERS_FAILURE, error }),
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/redux/actions/users.actions.js